/**
 * determines if two arrays contain equivalent objects (equality check via discriminator key; order irrelevant)
 * @param arr array of objects
 * @param arrToCompare array of objects to check for content equality
 * @param discriminatorKey object key used to determine object equality
 * @returns true if arrays contain same objects; false otherwise
 */
export default function isArrayContentsEqual<O extends { [K in keyof O]: unknown }>(
  arr: O[],
  arrToCompare: O[],
  discriminatorKey: keyof O,
): boolean {
  return (
    arr.length === arrToCompare.length &&
    arr.every((elm) => arrToCompare.find((elmToCompare) => elm[discriminatorKey] === elmToCompare[discriminatorKey]))
  );
}
